import React from "react";
import FieldTooltip from "./FieldTooltip";

const Input = ({
  name,
  id,
  type = "text",
  steps,
  placeholder = "",
  onChange,
  register,
  errors = {},
  options,
  className = "",
  min,
  title,
  svg,
  tooltipPlacement = "top",
  value = "",
}) => {
  const errorShowMessage = (error) => <p className="text-red-600">{error}</p>;

  return (
    <div>
      {(name || svg) && (
        <div className="flex w-full justify-start items-center gap-1">
          {name && <label htmlFor={id}>{name}</label>}
          {svg && (
            <FieldTooltip title={title} placement={tooltipPlacement}>
              {svg}
            </FieldTooltip>
          )}
        </div>
      )}
      <input
        id={id}
        type={type}
        step={steps}
        placeholder={placeholder}
        className={`border border-black rounded-md ${
          name || svg ? "mt-1" : ""
        } p-2 w-full ${className}`}
        min={min}
        defaultValue={value}
        onChange={onChange}
        {...(register && register(id, options))}
      />
      {errors[id] && errorShowMessage(errors[id].message)}
    </div>
  );
};

export default Input;
